// Agent color palette - cycles through these colors for each new agent
export const AGENT_COLOR_PALETTE = [
  "bg-blue-500",      // Blue
  "bg-purple-500",    // Purple
  "bg-red-500",       // Red
  "bg-yellow-500",    // Yellow
  "bg-green-500",     // Green
  "bg-indigo-500",    // Indigo
  "bg-cyan-500",      // Cyan
  "bg-pink-500",      // Pink
  "bg-orange-500",    // Orange
  "bg-teal-500",      // Teal
  "bg-blue-600",      // Dark Blue
  "bg-purple-600",    // Dark Purple
  "bg-red-600",       // Dark Red
];

/**
 * Generate a color for an agent based on its ID
 * Uses a hash of the ID to cycle through the color palette
 */
export function getAgentColor(agentId: string): string {
  if (!agentId) return AGENT_COLOR_PALETTE[0];

  // Simple hash function to convert ID to a number
  let hash = 0;
  for (let i = 0; i < agentId.length; i++) {
    const char = agentId.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }

  // Get absolute value and mod by palette length
  const colorIndex = Math.abs(hash) % AGENT_COLOR_PALETTE.length;
  return AGENT_COLOR_PALETTE[colorIndex];
}

/**
 * Get the next color in sequence for a new agent
 * Based on the number of existing agents
 */
export function getNextAgentColor(agentCount: number): string {
  const colorIndex = agentCount % AGENT_COLOR_PALETTE.length;
  return AGENT_COLOR_PALETTE[colorIndex];
}
